import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../../../shared/i18n/index.js';

export function NotFoundPage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div role="alert" aria-label="not-found" data-testid="page-not-found" style={{ padding: 48, textAlign: 'center' }}>
      <h1 style={{ fontSize: 'var(--font-size-3xl)', color: 'var(--color-text-muted)' }}>404</h1>
      <p>{t('errors.404.detail')}</p>
      <Link to="/dashboard">{t('errors.returnDashboard')}</Link>
    </div>
  );
}
